import { render, staticRenderFns } from "./textToImage.vue?vue&type=template&id=986b5076&scoped=true&"
import script from "./textToImage.vue?vue&type=script&lang=js&"
export * from "./textToImage.vue?vue&type=script&lang=js&"
import style0 from "./textToImage.vue?vue&type=style&index=0&id=986b5076&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986b5076",
  null
  
)

export default component.exports